export const environment = {
	API_URL: process.env.REACT_APP_API_BASE_URL || '',
	SIGNALR_URL: process.env.REACT_APP_SIGNALR_URL || '',
	PUBLIC_URL: process.env.PUBLIC_URL || '',
	AD_B2C_Tenant: process.env.REACT_APP_AD_B2C_TENANT || '',
	AD_B2C_SignInPolicy: process.env.REACT_APP_AD_B2C_SIGN_IN_POLICY || '',
    AD_B2C_ResetPasswordPolicy: process.env.REACT_APP_AD_B2C_RESET_PASSWORD_POLICY || '',
	AD_B2C_ApplicationId: process.env.REACT_APP_AD_B2C_APPLICATION_ID || '',
	AD_B2C_ReactRedirectUri: process.env.REACT_APP_AD_B2C_REACT_REDIRECT_URI || '',
	Cesium_Default_Access_Token: process.env.REACT_APP_CESIUM_DEFAULT_ACCESS_TOKEN || '',
	Elevation_Access_Token:  process.env.REACT_APP_ELEVATION_ACCESS_TOKEN || '',
	SAS_Token: process.env.REACT_APP_SAS_TOKEN || '',
	Google_Api_Key: process.env.REACT_APP_GOOGLE_API_KEY,
	IOS_App_Url: process.env.REACT_APP_IOS_APP_URL || '',
	Android_App_Url: process.env.REACT_APP_ANDROID_APP_URL || ''
};


